/**
 * Environment Variables Configuration
 *
 * This module reads environment variables from process.env (set via .env files)
 * All environment variables must be prefixed with REACT_APP_ to be accessible in Create React App
 *
 * Usage:
 * - Development: Use .env.development file
 * - Staging: Use .env.staging file
 * - QA: Use .env.qa file
 * - UAT: Use .env.uat file
 * - Production: Use .env.production file
 *
 * To switch environments, use the appropriate build script:
 * - npm run build (uses .env.development)
 * - npm run build:staging (uses .env.staging)
 * - npm run build:qa (uses .env.qa)
 * - npm run build:uat (uses .env.uat)
 * - npm run build:production (uses .env.production)
 */

export default {
  // Application Environment (DEV, STAGING, QA, UAT, PROD)
  // Falls back to "PROD" if not set in environment
  APP_ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT || "PROD",

  // Enable/disable upload logs (set to false to disable all upload-related console logs)
  // Falls back to false if not set in environment
  ENABLE_UPLOAD_LOGS:
    process.env.REACT_APP_ENABLE_UPLOAD_LOGS === "true" || false,
};
